import React from "react";
import Button from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

type Props = {
  onBack: () => void;
  className?: string;
};

const BackButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ onBack, className }, ref) => {
    const { t } = useTranslation("common");

    function handleClick() {
      onBack();
    }

    return (
      <Button
        ref={ref}
        type={"button"}
        onClick={handleClick}
        size={"xl"}
        className={cn(className)}
      >
        {t("button.back")}
      </Button>
    );
  }
);

BackButton.displayName = "BackButton";

export default BackButton;
